export default function (callback, time = 200) {
  let interval;

  return (...args) => {
  	clearTimeout(interval);

  	return new Promise((resolve) => {
	  	interval = setTimeout(() => {
	  		interval = null;

	  		callback(...args);
	  		resolve();
	  	}, time);
  	});
  };  
}
